<div dynamicGrid [tableContainerElement]="tableContainer" [selector]="selector" fxLayout="column" fxLayoutGap="10px">
  <div class="flex-row">
    <h2 class="flex-cell page-header">Mantenimiento de Transportistas por Origen/Destino
    </h2>
  </div>
  <article class="table-header" *ngIf="canAddOrEdit">
    <button class="button1" color="primary" mat-icon-button (click)="addRow()">
      <mat-icon title='Add Row'>add_circle</mat-icon>
    </button>
    <button class="button1" color="primary" mat-icon-button (click)="save()" [disabled]="saveButtonDisabled">
      <mat-icon title='Save'>save</mat-icon>
    </button>
  </article>


  <div #tableContainer class="table-container">
    <table mat-table matSort [dataSource]="dataSource">
      <ng-container matColumnDef="origenField">
        <th mat-header-cell class="mat-header-cell" scope="col" *matHeaderCellDef mat-sort-header> Origen
          <fab-string-filter #tableFilter columnDef="origenField"
                             (filterChange)="filterChange($event);"></fab-string-filter>
        </th>
        <td class="cell-width-xltext" mat-cell *matCellDef="let element">
          <div *ngIf="!element.isAdd && !element.isEdit; else origenBox">
            {{element.origenField}}
          </div>

          <ng-template #origenBox class="cell-width-xltext">
            <mat-form-field #matOrigenField class="cell-width-xltext" appearance="fill">
              <mat-label>Origen</mat-label>
              <input matInput
                     [(ngModel)]="element.origenField"
                     [matAutocomplete]="autoOrigen"
                     (ngModelChange)="onOrigenChange(element, matOrigenField)"
                     required>
              <mat-autocomplete #autoOrigen="matAutocomplete">
                <mat-option *ngFor="let origen of origenFilter(element)"
                            [value]="origen">
                  {{ origen }}
                </mat-option>
              </mat-autocomplete>
              <mat-icon matPrefix *ngIf="isDirtyAndNotAdd(element,'origen')"
                        color="warn" class="dirty-indicator">info
              </mat-icon>
            </mat-form-field>
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="destinoField">
        <th mat-header-cell class="mat-header-cell" scope="col" *matHeaderCellDef mat-sort-header> Destino
          <fab-string-filter #tableFilter columnDef="destinoField"
                             (filterChange)="filterChange($event);"></fab-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-xltext">
          <div *ngIf="!element.isAdd && !element.isEdit; else origenBox">
            {{element.destinoField}}
          </div>

          <ng-template #origenBox class="cell-width-xltext">
            <mat-form-field #matDestinoField class="cell-width-xltext" appearance="fill">
              <mat-label>Destino</mat-label>
              <input matInput
                     [(ngModel)]="element.destinoField"
                     [matAutocomplete]="autoDestino"
                     (ngModelChange)="onDestinoChange(element, matDestinoField)"
                     required>
              <mat-autocomplete #autoDestino="matAutocomplete">
                <mat-option *ngFor="let destino of destinoFilter(element)"
                            [value]="destino">
                  {{ destino }}
                </mat-option>
              </mat-autocomplete>
              <mat-icon matPrefix *ngIf="isDirtyAndNotAdd(element,'destinoCode')"
                        color="warn" class="dirty-indicator">info
              </mat-icon>
            </mat-form-field>
          </ng-template>
        </td>
      </ng-container>


      <ng-container matColumnDef="transporteField">
        <th mat-header-cell class="mat-header-cell" *matHeaderCellDef mat-sort-header> Transporte
          <fab-string-filter #tableFilter columnDef="transporteField"
                             (filterChange)="filterChange($event);"></fab-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-xltext">
          <div *ngIf="!element.isAdd && !element.isEdit; else transporteBox">
            {{element.transporteField}}
          </div>
          <ng-template #transporteBox>
            <mat-form-field #matTransporteField class="cell-width-xltext" appearance="fill">
              <mat-label>Transporte</mat-label>
              <input matInput
                     [(ngModel)]="element.transporteField"
                     [matAutocomplete]="autoTransporte"
                     (ngModelChange)="onTransporteChange(element, matTransporteField)"
                     required>
              <mat-autocomplete #autoTransporte="matAutocomplete">
                <mat-option *ngFor="let transporte of transporteFilter(element)"
                            [value]="transporte">
                  {{ transporte }}
                </mat-option>
              </mat-autocomplete>
              <mat-icon matPrefix *ngIf="isDirtyAndNotAdd(element,'codTransp')"
                        color="warn" class="dirty-indicator">info
              </mat-icon>
            </mat-form-field>
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header> Estado
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-mtext">
          <div *ngIf="!element.isEdit; else statusBox">
            <span *ngIf="element.estado">Active</span>
            <span *ngIf="!element.estado">Inactive</span>
          </div>
          <ng-template #statusBox>
            <mat-form-field appearance="fill" class="cell-width-mtext">
              <mat-select [(ngModel)]="element.estado" name="estado">
                <mat-option [value]=true>
                  Active
                </mat-option>
                <mat-option [value]=false>
                  Inactive
                </mat-option>
              </mat-select>
              <mat-icon matPrefix *ngIf="isDirtyAndNotAdd(element,'estado')"
                        color="warn" class="dirty-indicator">info
              </mat-icon>
            </mat-form-field>
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="fecCreacion">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fec Creación
          <fab-date-filter #tableFilter columnDef="fecCreacion" [operators]="dateOperators"
                           (filterChange)="filterChange($event);"></fab-date-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-mtext">
          <div>
            {{element.fecCreacion  | date:'dd/MM/yyyy'}}
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="usrCreacion">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Usu Creación
          <fab-string-filter #tableFilter columnDef="usrCreacion" [operators]="operators"
                             (filterChange)="filterChange($event);"></fab-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-mtext">
          <div>
            {{element.usrCreacion}}
          </div>
        </td>
      </ng-container>


      <ng-container matColumnDef="fecModif">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fec Modificación
          <fab-date-filter #tableFilter columnDef="fecModif" [operators]="dateOperators"
                           (filterChange)="filterChange($event);"></fab-date-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-mtext">
          <div>
            {{element.fecModif  | customDate}}
          </div>
        </td>
      </ng-container>


      <ng-container matColumnDef="usrModif">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Usu Modificación
          <fab-string-filter #tableFilter columnDef="usrModif" [operators]="operators"
                             (filterChange)="filterChange($event);"></fab-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-mtext">
          <div>
            {{element.usrModif}}
          </div>
        </td>
      </ng-container>


      <ng-container matColumnDef="isEdit">
        <th mat-header-cell *matHeaderCellDef>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-smtext">
          <div class="btn-edit" *ngIf="canAddOrEdit">
            <div *ngIf="!element.isEdit && !element.isAdd">
              <button class="button1" color="secondary" mat-icon-button (click)="editRow(element)">
                <mat-icon title='Edit'>create</mat-icon>
              </button>
            </div>
          </div>
          <div class="btn-edit" *ngIf="canAddOrEdit">
            <div *ngIf="element.isEdit || element.isAdd">
              <button class="button1" color="tertiary" mat-icon-button (click)="cancelRow(element)">
                <mat-icon title='Edit'>cancel</mat-icon>
              </button>
            </div>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsToDisplay;sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>

    </table>

  </div>
  <mat-paginator [length]="resultsLength" [pageSize]="pageSize" [pageSizeOptions]="[10, 15, 20, 25]"></mat-paginator>
</div>
